module.exports = __webpack_public_path__ + "img/degustation.f58441cd.jpg";